export default __webpack_public_path__ + "static/media/symbol-thanks.c095e8b8.svg";